/* eslint-disable @typescript-eslint/camelcase */
import React, { useEffect } from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import { useDispatch, useSelector } from 'react-redux'
import { Col } from 'styled-bootstrap-grid'
import { getCollectorStat } from '../../features/stats/selector'
import { StatsActions } from '../../features/stats/actions'
import { Page } from '../../components/Page'
import { Layout } from '../../components/Page/Layout'
import { Title } from '../../components/Text'
import { Row } from '../../components/Grid'

export const Stats = () => {
  const dispatch = useDispatch()
  const collectorStats = useSelector(getCollectorStat)

  useEffect(() => {
    dispatch(StatsActions.fetchAllCollectorStats())
  }, [dispatch])

  if (!collectorStats) {
    return (
      <Page>
        <Layout>
          <Title size="XL">Statistiche</Title>
          <div>Loading....</div>
        </Layout>
      </Page>
    )
  }

  const data = [
    {
      name: 'Total',
      flusso_2: collectorStats.flowChat,
      flusso_1: collectorStats.flowRadar
    },
    {
      name: 'non registrati',
      flusso_2: collectorStats.signup1Chat,
      flusso_1: collectorStats.signup1Radar
    },
    {
      name: 'registrati',
      flusso_2: collectorStats.signup2Chat,
      flusso_1: collectorStats.signup2Radar
    },
    {
      name: 'apertura frame',
      flusso_2: collectorStats.rateplanChat,
      flusso_1: collectorStats.rateplanRadar
    },
    {
      name: 'acquisto',
      flusso_2: collectorStats.premiumChat,
      flusso_1: collectorStats.premiumRadar
    }
  ]

  return (
    <Page>
      <Layout>
        <Title size="XL">Statistiche</Title>
        <Row>
          <Col md={12} alignSelf="center">
            <BarChart
              width={1200}
              height={600}
              data={data}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="flusso_2" stackId="a" fill="#8884d8" label={{ fill: 'black', fontSize: 12 }} />
              <Bar dataKey="flusso_1" stackId="b" fill="#82ca9d" label={{ fill: 'black', fontSize: 12 }} />
            </BarChart>
          </Col>
        </Row>
      </Layout>
    </Page>
  )
}
